import { render } from "./ReportDoc.vue?vue&type=template&id=31cc5c5a&scoped=true"
import script from "./ReportDoc.vue?vue&type=script&lang=js"
export * from "./ReportDoc.vue?vue&type=script&lang=js"

import "./ReportDoc.vue?vue&type=style&index=0&id=31cc5c5a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cc5c5a"]])

export default __exports__